import React from "react";
 import { Eye, EyeOff } from "lucide-react";
import { Button } from "../components/ui/button";

interface PasswordToggleProps {
  className?: string;
  showPassword: boolean;
  setShowPassword: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PasswordToggle: React.FC<PasswordToggleProps> = ({ className,showPassword, setShowPassword }) => {
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className={`absolute top-0 right-0 h-full px-3 py-2 hover:bg-transparent ${className}`}
      onClick={() => setShowPassword((prev) => !prev)}
    >
      {showPassword ? <Eye className="w-4 h-4" aria-hidden="true" /> : <EyeOff className="w-4 h-4" aria-hidden="true" />}
      <span className="sr-only">{showPassword ? "Hide password" : "Show password"}</span>
    </Button>
  );
};

 